import React from "react";
import { MarkdownPage } from "./MarkdownPage";

export const ExternalGatewayPage = () => (
  <MarkdownPage file="ExternalGateway.md" />
);
